var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownloadOutline24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.002 2a.9.9 0 0 1 .9.9v11.002l4.562-4.631a.9.9 0 0 1 1.283 1.263l-6.104 6.195a.9.9 0 0 1-1.283-.001l-6.09-6.206a.9.9 0 0 1 1.285-1.26l4.547 4.633V2.9a.9.9 0 0 1 .9-.9Zm-8 18.1a.9.9 0 0 1 .9-.9h14.2a.9.9 0 0 1 0 1.8h-14.2a.9.9 0 0 1-.9-.9Z",
  clipRule: "evenodd"
})));
export { SvgDownloadOutline24 as ReactComponent };